export function AddFocusDirective($timeout) {
	return {
		restrict: 'A',
		scope: { addFocus: '<sbAddFocus'},
		link: function(scope, element, attrs) {
			scope.$watch('addFocus', (focus) => {
				if (focus){
					$timeout(function(){
						element.focus();
					});
				}
			});
		}
	};
}

AddFocusDirective.$inject = [
	'$timeout'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/addFocus/addFocus.ts